class ReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.reviews-carousel__track');
    this.slides = this.querySelectorAll('.reviews-carousel__slide');
    this.prevBtn = this.querySelector('.reviews-carousel__nav--prev');
    this.nextBtn = this.querySelector('.reviews-carousel__nav--next');
    this.dotsContainer = this.querySelector('.reviews-carousel__dots');
    this.currentIndex = 0;
  }

  connectedCallback() {
    if (!this.track || this.slides.length === 0) return;

    this.createDots();
    this.bindEvents();
    this.updateDots();
  }

  createDots() {
    if (!this.dotsContainer) return;

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('reviews-carousel__dot');
      dot.setAttribute('aria-label', `Go to review ${index + 1}`);
      dot.addEventListener('click', () => this.goToSlide(index));
      this.dotsContainer.appendChild(dot);
    });
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigate(-1));
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigate(1));
    }

    // Update dots on scroll
    this.track.addEventListener('scroll', () => {
      this.handleScroll();
    });

    // Keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.navigate(-1);
      } else if (e.key === 'ArrowRight') {
        this.navigate(1);
      }
    });
  }

  handleScroll() {
    const scrollLeft = this.track.scrollLeft;
    const slideWidth = this.slides[0].offsetWidth + this.getSlideGap();
    const newIndex = Math.round(scrollLeft / slideWidth);

    if (newIndex !== this.currentIndex) {
      this.currentIndex = Math.max(0, Math.min(newIndex, this.slides.length - 1));
      this.updateDots();
    }
  }

  navigate(direction) {
    const slidesVisible = this.getSlidesVisible();
    const maxIndex = this.slides.length - slidesVisible;

    this.currentIndex = Math.max(0, Math.min(this.currentIndex + direction, maxIndex));
    this.scrollToCurrentSlide();
    this.updateDots();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.scrollToCurrentSlide();
    this.updateDots();
  }

  scrollToCurrentSlide() {
    const slide = this.slides[this.currentIndex];
    if (slide) {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  getSlidesVisible() {
    const containerWidth = this.track.offsetWidth;
    const slideWidth = this.slides[0].offsetWidth + this.getSlideGap();
    return Math.floor(containerWidth / slideWidth) || 1;
  }

  getSlideGap() {
    const computedStyle = getComputedStyle(this.track);
    const gap = computedStyle.columnGap || computedStyle.gap || '0px';
    return parseFloat(gap) || 0;
  }

  updateDots() {
    if (!this.dotsContainer) return;

    const dots = this.dotsContainer.querySelectorAll('.reviews-carousel__dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.currentIndex);
    });
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
